export default __webpack_public_path__ + "static/media/tik-tok.ee6e4c64.png";